import Type from './Type';
export function isILinkRemote(discourse) {
    return discourse.type === Type.Remote;
}
export {
    isILinkRemote as isIRemote
};
export default isILinkRemote;    //# sourceMappingURL=isIRemote.js.map
